import React from 'react'
import PropTypes from 'prop-types'
import { Status, JOB_TYPES } from '../../../constants'

const initialState = {
  deletingVp: false,
  disableActions: false,
  hasTracking: false,
  hasScenes: false,
  hasTrackingJob: false,
  showStartTracking: false,
  isOnHold: false,
  errorTryAgain: false
}

function TrackingJob(props) {
  const [state, setState] = React.useState(initialState)

  React.useEffect(() => {
    const { vp, deletingVp } = props
    const hasTracking = vp.files[JOB_TYPES.TRACKING.file]
    const hasScenes = Boolean(vp.scenes && vp.scenes.length)
    const hasTrackingJob = !vp.files[JOB_TYPES.TRACKING.file] && props.trackingJob
    const showStartTracking = false // Users can not be able to start this job
    const isOnHold = !vp.files.video && !vp.files[JOB_TYPES.TRACKING.file] && !props.trackingJob
    const errorTryAgain =
      hasTrackingJob && props.trackingJob && props.trackingJob.status === Status.FAILED

    if (deletingVp) {
      setState({
        ...initialState,
        deletingVp: true
      })
      return
    }

    if (hasTracking) {
      // this two states have to be combined for use on SceneMenuItem.js
      setState({
        ...initialState,
        hasTracking: true,
        hasScenes
      })
      return
    }

    if (hasTrackingJob) {
      // this two states have to be combined for use on SceneMenuItem.js
      setState({
        ...initialState,
        hasTrackingJob: true,
        hasScenes
      })
      return
    }

    if (errorTryAgain) {
      setState({
        ...initialState,
        errorTryAgain: true
      })
      return
    }

    if (showStartTracking) {
      setState({
        ...initialState,
        showStartTracking: true
      })
      return
    }

    if (isOnHold) {
      setState({
        ...initialState,
        isOnHold: true
      })
      return
    }

    setState({ ...initialState, disableActions: true })
  }, [props.vp, props.deletingVp, props.trackingJob, props.isVpCreatedInCloud])

  const renderFn = props.render || props.children // eslint-disable-line
  return renderFn(state)
}

TrackingJob.propTypes = {
  vp: PropTypes.object.isRequired,
  trackingJob: PropTypes.object, // Don't use {} as a default prop for this
  isVpCreatedInCloud: PropTypes.bool.isRequired,
  deletingVp: PropTypes.bool.isRequired
}

export default TrackingJob
